(ns frontend.view.modals.association.view
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.view.modals.association.events :as events]
   [common.schema.associations :as associations]
   [common.schema.entity-type-names :as entity-type-names]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.modals.association.single-view :as single-association]
   [frontend.view.modals.association.import-view :as import-associations]
   [common.util :as cu]
   [common.entity :as entity]
   [frontend.state.current-session :as session]
   [frontend.view.modals.events :as modals]
   [frontend.utils :as fu]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.tab-strip.view :as tab-strip]
   [frontend.view.modals.association.sub :as sub]
   [ui.components.modal.style :as modal-style]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [cljs.reader :as edn]))

(defonce modal-key :association-modal)

(defn import-available?
  [entity-type target-type]
  (and
   (= target-type :entity.type/person)))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?] :as modal-props}]
  (r/create-class
   {:component-will-unmount (fn []
                              (rf/dispatch [::events/cleanup]))
    :reagent-render
    (fn [{:keys [shown? close-modal! props state class-name topmost?] :as modal-props}]
      (let [selected-tab @(rf/subscribe [::sub/selected-tab])
            selected-tab (or selected-tab :single)
            import-flow-started? @(rf/subscribe [::sub/import-flow-started?])
            import-flow-ready? @(rf/subscribe [::sub/import-flow-ready?])
            {:keys [entity-id entity-type target-type create-on-fly?
                    success-callback-event]} props
            on-success! (fn []
                          (close-modal!)
                          ;; TODO: solve this callback events this somehow better?
                          (when (vector? success-callback-event)
                            (rf/dispatch success-callback-event)))
            on-close! (fn []
                        (close-modal!))
            association-types (->> (:association-types @state)
                                   (map (fn [at]
                                          (edn/read-string (:value at)))))

            submit-button-disabled?
            (case selected-tab
              :single (not (events/form-ready? state))
              :import (not import-flow-ready?))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true
          :size          (when (and import-flow-started?
                                    (= selected-tab :import))
                           ::modal-style/lg)}
         (loc/tr :new-association-title [(loc/tr target-type)])
         [:<>
          (when (import-available? entity-type target-type)
            [:<>
             [tab-strip/view
              {:tabs         [{:value :single
                               :label (loc/tr :add- [(string/lower-case (loc/tr target-type))])}
                              {:value :import
                               :label (loc/tr :import- [(string/lower-case (entity-type-names/get-plural target-type :en))])}]
               :selected-tab selected-tab
               :on-change!   (fn [selected-tab]
                               (rf/dispatch [::events/set-selected-tab selected-tab]))}]
             [:div.mb-4]])

          (case selected-tab
            :single [single-association/view modal-props]
            :import [import-associations/view modal-props])]
         [modal/footer-children-left-and-right
          [[button/secondary-hollow
            {:on-click on-close!}
            (loc/tr :cancel)]]
          [[button/primary-solid
            {:disabled? submit-button-disabled?
             :on-click  (fn [e]
                          (case selected-tab
                            :single (events/send state entity-id association-types target-type on-success!)
                            :import (rf/dispatch [::events/create-associations entity-id on-success!])))}
            (loc/tr :save)]]]]))}))



